import React, { FC } from "react"
import { useSelector } from "react-redux"

import { getFeatures } from "@/onboarding/features/product/selectors"
import { useModal } from "@/helpers/useModal"

import ApplyToToursModal from "./ApplyToToursModal"

// Section-level entry point for the operator Apply to Tour/s flow.
// Renders on every section that has an importable field set —
// apply is the push twin of the section Importer's pull — and only when the
// operator holds an editable bid on the viewed tour (the applyToTours
// feature, flipflop-gated). Opens the multi-section modal with this section
// pre-checked.
const ApplyToToursButton: FC<{
  fieldNames: string[]
  sectionName: string
  sectionTitle: string
}> = ({ fieldNames, sectionName, sectionTitle }) => {
  const features = useSelector(getFeatures)

  const toggleModal = useModal((props) => (
    <ApplyToToursModal {...props} initialSectionName={sectionName} />
  ))

  if (!features.general.product.applyToTours || fieldNames.length === 0) {
    return null
  }

  return (
    <span
      className="cursor-pointer"
      onClick={toggleModal}
      title="Apply to Tour/s"
      role="button"
      aria-label={`Apply ${sectionTitle} to Tour/s`}
    >
      <i className="fas fa-share-square" />
    </span>
  )
}

export default ApplyToToursButton
